module.exports = __webpack_public_path__ + "img/icon_map_13_off_100.75b39123.png";